import { Tokens } from '@tmov/design-system/theme/types';
import styled from 'styled-components';

export const TableContainer = styled.div`
  padding-top: 32px;

  overflow: visible;
  background-color: ${Tokens.eixods.colors.neutral.grey[0]};
  padding: 32px;
  border-radius: 8px;
`;
